/* eslint-disable camelcase */

const JobsUsers = {
  "irene@stagedesign.es": { name: "Irene" },
  "miguel@ship-quik.com": { name: "Miguel" },
  "borja@stagedesign.es": { name: "Borja" },
  "lydia@stagedesign.es": { name: "Lydia" },
  "agustina@stagedesign.es": { name: "Agustina" },
  "imma@stagedesign.es": { name: "Imma" },
  "guillermo@stagedesign.es": { name: "Guillermo" },
  "nicoleta@stagedesign.es": { name: "Nicoleta" },
  "laura@stagedesign.es": { name: "Laura" },
  "chiara@stagedesign.es": { name: "Chiara" },
  "alex@stagedesign.es": { name: "Alex" },
  "anacarrasco@stagedesign.es": { name: "Anacarrasco" },
  "anna@stagedesign.es": { name: "Anna" },
  "mikael@stagedesign.es": { name: "Mikael" },
  "gemma@stagedesign.es": { name: "Gemma" },
  "alejandra@stagedesign.es": { name: "Alejandra" },
};

export default JobsUsers;
